// The app's ONE default transport — fetch, plus the fact every page needs and
// none should discover alone: THE SESSION IS GONE.
//
// Found on a phone at 06:37 (2026-08-14): the dj_session cookie's Max-Age
// lapsed under a suspended Safari tab, the resumed shell still wore yesterday's
// identity from React state, and every panel painted "no session token was
// presented" refusal cards with Retry buttons that could never succeed. A 401
// mid-session is not a panel's error — it is a shell-level fact, and exactly
// one thing should happen: the shell flips to the sign-in prompt.
//
// So this wraps fetch and, on any 401, dispatches ONE window event before
// handing the response back unchanged. Every api module already accepts an
// injectable `fetchImpl` defaulting to bare fetch; those defaults move here.
// Tests that inject their own fetch are untouched. auth.ts deliberately stays
// on bare fetch: a wrong password answers 401 on the sign-in surface itself,
// and that must never re-trigger the prompt it came from.

/** The window event App.tsx listens for; detail carries nothing — the fact is the message. */
export const UNAUTHENTICATED_EVENT = 'dj:unauthenticated';

export const appFetch: typeof fetch = async (input, init) => {
  const response = await fetch(input, init);
  if (response.status === 401 && typeof window !== 'undefined') {
    window.dispatchEvent(new Event(UNAUTHENTICATED_EVENT));
  }
  return response;
};
